module.exports = __webpack_public_path__ + "img/bindButton.31bd9dc9.png";